export * from './type-selection-list';

import { TypeSelectionListComponent } from './type-selection-list';

export const RoomMolecules = [
    TypeSelectionListComponent
];